import * as React from "react";
import cloudStore from "../../store/CloudStore";
import clsx from "clsx";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import { makeStyles } from "@material-ui/core/styles";
import { Redirect, withRouter } from "react-router-dom";
import { productionUrl, rootUrl } from "../../Api";
import { ExitToApp } from "@material-ui/icons";

let body = document.body,
  html = document.documentElement;

let height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
    [theme.breakpoints.down("sm")]: {
      // display: 'none'
    },
  },
  selectButton: {
    marginRight: 12,
  },
  navigation: {
    [theme.breakpoints.down("sm")]: {
      // display: 'none'
    },
  },
  navigationMerchantName: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
    paddingTop: 7,
    minWidth: 200,
  },
  drawerPaper: {
    height: height,
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      // display: 'none'
    },
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: 0, // theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "scroll",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

function DashboardTopBar(props) {
  const classes = useStyles();
  const [logout, setLogout] = React.useState(false);

  if (logout === true) {
    return <Redirect to="/login" />;
  }

  return (
    <AppBar className={clsx(classes.appBar, props.open && classes.appBarShift)}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          title={"Open menu"}
          onClick={props.handleDrawerOpen}
          className={clsx(classes.menuButton, props.open && classes.menuButtonHidden)}
        >
          <MenuIcon />
        </IconButton>
        <div style={{ display: "flex", flexDirection: "row", flex: "1 1" }}>
          <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
            {cloudStore.merchant?.name}
          </Typography>
          {rootUrl !== productionUrl && cloudStore.userRoles?.includes("superadmin") && (
            <Typography variant={"h5"} style={{ alignSelf: "center", position: "absolute", left: "calc(50% - 61px)" }}>
              DEVELOPMENT
            </Typography>
          )}
        </div>
        <IconButton
          color="inherit"
          onClick={() => {
            localStorage.removeItem("access_token");
            setLogout(true);
          }}
          title={"Uitloggen"}
        >
          <ExitToApp />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}

export default withRouter(DashboardTopBar);
